import React from 'react';

// Last line of defence for the code-split routes (Phase 46): if a page still
// fails to load or render after lazyPage's automatic reload, show a way out
// instead of a blank screen.
class LoadErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4 bg-pp-bg px-6 text-center">
        <p className="max-w-sm text-[15px] leading-relaxed text-pp-muted">
          Something went wrong loading this page. Reloading usually fixes it, especially right
          after a new version of Intercept API is released.
        </p>
        <button type="button" className="pp-btn pp-btn-primary" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}

export default LoadErrorBoundary;
